import { cn } from '../lib/cn.js';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  className?: string;
}

const sizeMap = { sm: 'size-4 border-2', md: 'size-5 border-2', lg: 'size-7 border-[3px]' } as const;

export function Spinner({ size = 'md', label = 'Loading', className }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-live="polite"
      className={cn('inline-flex items-center justify-center', className)}
    >
      <span
        aria-hidden="true"
        className={cn(
          'inline-block rounded-full border-border-strong border-t-accent-base animate-spin',
          sizeMap[size],
        )}
      />
      <span className="sr-only">{label}</span>
    </span>
  );
}
